import { createSelector } from 'reselect';

import { TextOverlayLockedFeatures } from 'blocks/TextOverlayModal/v2';
import { selectedOverlayFontFamilyLockStateSelector } from 'redux/modules/embed/selectors';

/**
 * Maps the selected overlay's font-family lock state into the
 * {@link TextOverlayLockedFeatures} prop shape the v2 text overlay modal
 * consumes.  Resolves to `undefined` when nothing is locked so the modal
 * treats the overlay as fully editable.
 */
export const editTextLockedFeaturesSelector = createSelector(
  selectedOverlayFontFamilyLockStateSelector,
  (fontFamilyLock): TextOverlayLockedFeatures | undefined =>
    fontFamilyLock.disabled
      ? { fontFamily: { tooltip: fontFamilyLock.tooltip } }
      : undefined,
);
